import { schema } from 'normalizr';

import { processOriginNetwork } from '../strategies/originNetwork';

export const originNetworkSchema: schema.Entity = new schema.Entity(
  'userOriginNetworks',
  {},
  { processStrategy: processOriginNetwork }
);
